import { React, useContext, useState } from "react";
import { AppContext } from "../App";
import { MdClose, MdMenu, MdKeyboardArrowDown } from "react-icons/md";
import { hospitalInfo } from "../content/hospitalContent";
import logo from "../assets/logo.png";
import logo_worded from "../assets/logo_worded.png";
import { IoMdCall } from "react-icons/io";

export default function TopBar() {
  const appContext = useContext(AppContext);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isOfferingsOpen, setIsOfferingsOpen] = useState(false);
  const [isMediaOpen, setIsMediaOpen] = useState(false);

  function goTo(item) {
    appContext.navTo({ item });
    setIsAboutOpen(false);
    setIsOfferingsOpen(false);
    setIsMediaOpen(false);
  }

  return (
    <div className="TopBar topbar-modern">
      <style>{`
        .dropdown-container {
          position: relative;
          display: inline-block;
        }

        .dropdown-menu {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%) translateY(10px);
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          padding: 8px;
          min-width: 180px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
        }

        .dropdown-container:hover .dropdown-menu {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }

        .dropdown-item {
          background: transparent;
          border: none;
          padding: 10px 16px;
          text-align: left;
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
          border-radius: 8px;
          transition: 0.2s;
          width: 100%;
          cursor: pointer;
        }

        .dropdown-item:hover {
          background: rgba(0,0,0,0.05);
          color: var(--secondaryColor);
        }

        .topbar-modern-link.has-arrow {
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
      `}</style>

      <div className="body topbar-modern-body">
        <div className="container d-flex align-items-center justify-content-between h-100">
          <button type="button" className="hospital-topbar__brand" onClick={() => goTo("home")}>
            <span className="d-flex align-items-center gap-2">
              <img src={logo} className="mMobileOnly" width={55} alt={`${hospitalInfo.shortName} logo`} />
              <img src={logo} className="mDesktopOnly" width={50} alt={`${hospitalInfo.shortName} logo`} />
              <img src={logo_worded} className="mDesktopOnly" width={120} alt={`${hospitalInfo.shortName} logo`} />
            </span>
          </button>

          <div className="topbar-modern-nav-wrap mDesktopOnly">
            <div className="d-flex align-items-center">
              
              {/* Group 1: Landing Root */}
              <button
                className={`topbar-modern-link ${appContext.navItem === "home" ? "active" : ""}`}
                onClick={() => goTo("home")}
              >
                Home
              </button>

              {/* Group 2: About Dropdown */}
              <div className="dropdown-container">
                <button 
                  className={`topbar-modern-link has-arrow ${['about_us', 'team', 'testimonials', 'careers'].includes(appContext.navItem) ? 'active' : ''}`}
                  onMouseEnter={() => setIsAboutOpen(true)}
                  onMouseLeave={() => setIsAboutOpen(false)}
                >
                  About Us <MdKeyboardArrowDown size={18} style={{transform: isAboutOpen ? 'rotate(180deg)' : 'rotate(0)', transition: '0.3s'}} />
                </button>
                <div className="dropdown-menu">
                  <button className="dropdown-item" onClick={() => goTo("about_us")}>Our Story</button>
                  <button className="dropdown-item" onClick={() => goTo("team")}>Staff</button>
                  <button className="dropdown-item" onClick={() => goTo("testimonials")}>Testimonials</button>
                </div>
              </div>

              {/* Group 3: Offerings Dropdown */}
              <div className="dropdown-container">
                <button 
                  className={`topbar-modern-link has-arrow ${['services', 'products', 'portfolio'].includes(appContext.navItem) ? 'active' : ''}`}
                  onMouseEnter={() => setIsOfferingsOpen(true)}
                  onMouseLeave={() => setIsOfferingsOpen(false)}
                >
                  Services <MdKeyboardArrowDown size={18} style={{transform: isOfferingsOpen ? 'rotate(180deg)' : 'rotate(0)', transition: '0.3s'}} />
                </button>
                <div className="dropdown-menu">
                  <button className="dropdown-item" onClick={() => goTo("services")}>Our Services</button>
                  <button className="dropdown-item" onClick={() => goTo("products")}>Products</button>
                  <button className="dropdown-item" onClick={() => goTo("portfolio")}>Portfolio</button>
                </div>
              </div>

              {/* Group 4: Media Dropdown */}
              <div className="dropdown-container">
                <button 
                  className={`topbar-modern-link has-arrow ${['news', 'gallery'].includes(appContext.navItem) ? 'active' : ''}`}
                  onMouseEnter={() => setIsMediaOpen(true)}
                  onMouseLeave={() => setIsMediaOpen(false)}
                >
                  Media <MdKeyboardArrowDown size={18} style={{transform: isMediaOpen ? 'rotate(180deg)' : 'rotate(0)', transition: '0.3s'}} />
                </button>
                <div className="dropdown-menu">
                  <button className="dropdown-item" onClick={() => goTo("news")}>News & Updates</button>
                  <button className="dropdown-item" onClick={() => goTo("gallery")}>Gallery</button>
                </div>
              </div>

              <button
                className={`topbar-modern-link ${appContext.navItem === "careers" ? "active" : ""}`}
                onClick={() => goTo("careers")}
              >
                Careers
              </button>

            </div>
          </div>

          <div className="topbar-modern-desktop-actions d-flex align-items-center">
            <button className="btn btn-secondary btn-lg rounded-pill" onClick={() => appContext.navTo({ item: "contact_us" })}>
              Reach Out <IoMdCall />
            </button>
          </div>

          <button
            type="button"
            className="topbar-modern-menu-btn"
            data-open={appContext.isSideBarOpen}
            onClick={appContext.isSideBarOpen ? appContext.closeSideBar : appContext.openSideBar}
          >
            {appContext.isSideBarOpen ? <MdClose size={28} /> : <MdMenu size={28} />}
          </button>
        </div>
      </div>
    </div>
  );
}